export default __webpack_public_path__ + "static/media/map.03037716.png";